import React, { useState } from "react";
import "./forms.css";
function InputField({ id, label, note, type = "text", value, onChange }) {
  return (
    <div className="basic-form-line">
      <label htmlFor={id} className="font-semibold">
        {label}
      </label>
      <input
        id={id}
        name={id}
        type={type}
        value={value}
        onChange={onChange}
        className="border rounded p-2"
      />
      {note && <small className="text-gray-500">{note}</small>}
    </div>
  );
}

function DropdownField({ id, label, note, options = [], value, onChange }) {
  return (
    <div className="basic-form-line">
      <label htmlFor={id} className="font-semibold">
        {label}
      </label>
      <select
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        className="border rounded p-2"
      >
        <option value="">בחר...</option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      {note && <small className="text-gray-500">{note}</small>}
    </div>
  );
}

export default function BriefForm({setShowForm}) {
  const [formData, setFormData] = useState({});
const fieldLabels = {
  projectName: "שם פרוייקט",
  fullName: "שם הממלא",
  jobType: "סוג העבודה",
  videoTarget: "לאן הוידאו עולה",
  format: "פורמט",
  dimensions: "מידות",
  materials: "היכן החומרים",
  graphicExamples: "דוגמאות לקו גרפי",
  hasDesign: "האם קיים עיצוב"
};
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // תאריך של היום
    const today = new Date().toLocaleDateString("he-IL");

    // מיפוי ל-label:value
    const formattedData = Object.keys(formData).reduce((acc, key) => {
      acc[fieldLabels[key] || key] = formData[key];
      return acc;
    }, {});



    setShowForm("submitted")
    // שולח לשרת
    await fetch("/api/sendBriefForm", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        subject: `מילאו טופס בריף – ${today} – ע"י ${formData.fullName || "לא צויין שם"}`,
        data: formattedData,
      }),
    });

    // alert("הטופס נשלח בהצלחה!");
  };

  return (
    <form onSubmit={handleSubmit} className="form-elements">
 <h2 className="mb-s-15"  > בריף חדש</h2>
      <InputField
        id="projectName"
        label="שם פרוייקט"
        note="לדוגמה: סרטון לעמוד נחיתה "
        value={formData.projectName || ""}
        onChange={handleChange}
      />
<InputField
  id="fullName"
  label="שם מלא"
  note="לדוגמה: דוד בן גוריון"
  value={formData.fullName || ""}
  onChange={handleChange}
/>
      <InputField
        id="clientName"
        label="שם לקוח"
        note="נא להזין שם לקוח סופי"
        value={formData.clientName || ""}
        onChange={handleChange}
      />

      <DropdownField
        id="workType"
        label="סוג העבודה"
        note="בחר סוג"
        options={["וידאו", "תמונה סטטית", "אחר"]}
        value={formData.workType || ""}
        onChange={handleChange}
      />


{formData.workType === "וידאו" && 
     <InputField
        id="videoTarget"
        label="אם וידאו – לאן עולה?"
        note="למשל: פייסבוק, טיקטוק, טלוויזיה..."
        value={formData.videoTarget || ""}
        onChange={handleChange}
      />
}



{formData.workType === "אחר" && 
     <InputField
        id="otherTarget"
        label="אם אחר – פרט  ?"
        note="למשל: חתימת מייל מונפשת.."
        value={formData.otherTarget || ""}
        onChange={handleChange}
      />
}

      <DropdownField
        id="format"
        label="פורמט"
        note="בחר פורמט"
        options={["עומד", "שוכב", "קוביה", "אחר"]}
        value={formData.format || ""}
        onChange={handleChange}
      />

 
<InputField
  id="quantity"
  label="כמות"
  note="הכנס מספר (חיובי בלבד)"
  type="number"
  min="1"
  value={formData.quantity || ""}
  onChange={handleChange}
/>
      <InputField
        id="width"
        label="רוחב (בפיקסלים)"
        type="number"
        value={formData.width || ""}
        onChange={handleChange}
      />

      <InputField
        id="height"
        label="גובה (בפיקסלים)"
        type="number"
        value={formData.height || ""}
        onChange={handleChange}
      />

      <InputField
        id="materials"
        label="היכן החומרים?"
        note="לדוגמה: לינק"
        value={formData.materials || ""}
        onChange={handleChange}
      />

      <InputField
        id="graphicExamples"
        label="דוגמאות לקו גרפי"
        note="אפשר להוסיף לינקים או להעלות קובץ"
        value={formData.graphicExamples || ""}
        onChange={handleChange}
      />

      <DropdownField
        id="hasDesign"
        label="האם קיים עיצוב?"
        options={["כן", "לא"]}
        value={formData.hasDesign || ""}
        onChange={handleChange}
      />

 
      <button
         type="submit"
        className="btn-type-b btn-true-size mt-s-10"
   
        style={{ marginRight: 'auto' }}
      > 
 
        <p>שלח</p>
        <img src='./for-all-app/arrow1.svg'alt={`arrow`} style={{height:"12px"}} className=' '/>
      </button>


    </form>
  );
}
